export function nav() {

  const DOMAnimations = {
    
    /**
    * SlideUp
    *
    * @param {HTMLElement} element
    * @param {Number} duration
    * @returns {Promise<boolean>}
    */
    slideUp: function (element, duration = 600) {
      return new Promise(function (resolve, reject) {
        element.classList.add('is-animate');
        element.style.height = element.offsetHeight + 'px';
        element.style.transitionProperty = `height, margin, padding`;
        element.style.transitionDuration = duration + 'ms';
        element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = 0;
        element.style.marginBottom = 0;
        window.setTimeout(function () {
          element.classList.remove('is-animate');
          element.classList.remove('nav-show-tablet');
          element.classList.add('nav-hide-tablet');
          element.style.removeProperty('height');
          element.style.removeProperty('padding-top');
          element.style.removeProperty('padding-bottom');
          element.style.removeProperty('margin-top');
          element.style.removeProperty('margin-bottom');
          element.style.removeProperty('overflow');
          element.style.removeProperty('transition-duration');
          element.style.removeProperty('transition-property');
          resolve(false);
        }, duration)
      })
    },

    /**
    * SlideDown
    *
    * @param {HTMLElement} element
    * @param {Number} duration
    * @returns {Promise<boolean>}
    */
    slideDown: function (element, duration = 600) {
      return new Promise(function (resolve, reject) {
        element.classList.add('is-animate');
        element.style.removeProperty('display');
        let display = window.getComputedStyle(element).display;
        if(display === 'none') 
          element.classList.remove('nav-hide-tablet');
          element.classList.add('nav-show-tablet');
        let height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = 0;
        element.style.marginBottom = 0;
        element.offsetHeight;
        element.style.transitionProperty = `height, margin, padding`;
        element.style.transitionDuration = duration + 'ms';
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        window.setTimeout(function () {
          element.classList.remove('is-animate');
          element.style.removeProperty('height');
          element.style.removeProperty('overflow');
          element.style.removeProperty('transition-duration');
          element.style.removeProperty('transition-property');
        }, duration)
      })
    },

    /**
    * SlideToggle
    *
    * @param {HTMLElement} element
    * @param {Number} duration
    * @returns {Promise<boolean>}
    */
    slideToggle: function (element, duration = 600) {
      if (window.getComputedStyle(element).display === 'none') {
        return this.slideDown(element, duration);
      } else {
        return this.slideUp(element, duration);
      }
    }
  }

  const closest = (el, targetClass) => {
    for (let item = el; item; item = item.parentElement) {
      if (item.classList.contains(targetClass)) {
        return item
      }
    }
  }

  const langTrigger = document.querySelector('.js-nav-lang-trigger');
  const langNav = document.getElementById('nav-lang');
  if(!IS_TOUCH) {
    langTrigger.addEventListener('mouseenter', function(e) {
      document.body.classList.add('is-lang-nav-active');
      e.preventDefault();
    });
    langNav.addEventListener('mouseleave', function(e) {
      document.body.classList.remove('is-lang-nav-active');
      e.preventDefault();
    });
  } else {
    langTrigger.addEventListener('click', function(e) {
      document.body.classList.remove('is-nav-active');
      document.body.classList.remove('is-tablet-nav-active');
      for(let i = 0; i < parent.length; i++) {
        const el = parent[i];
        el.classList.remove('is-active');
      }
      if(document.body.classList.contains('is-lang-nav-active')){
        document.body.classList.remove('is-lang-nav-active');
      } else {
        document.body.classList.add('is-lang-nav-active');
      }
      e.preventDefault();
    });
  }

  const trigger = document.querySelectorAll('.js-nav-trigger');
  const parent = document.querySelectorAll('.js-nav');
  if(!IS_TOUCH) {
    for(let i = 0; i < trigger.length; i++) {
      const el = trigger[i];
      const _parent = closest(el, 'js-nav');
      if(_parent) {
        el.addEventListener('mouseenter', function(e) {
          document.body.classList.add('is-nav-active');
          _parent.classList.add('is-active');
        });
        _parent.addEventListener('mouseleave', function(e) {
          document.body.classList.remove('is-nav-active');
          _parent.classList.remove('is-active');
        });
      }
    }
  } else {
    for(let i = 0; i < trigger.length; i++) {
      const el = trigger[i];
      el.addEventListener('click', function(e) {
        const _parent = closest(el, 'js-nav');
        if(_parent) {
          document.body.classList.remove('is-lang-nav-active');
          if(_parent.classList.contains('is-active')){
            document.body.classList.remove('is-nav-active');
            _parent.classList.remove('is-active');
          } else {
            for(let i = 0; i < parent.length; i++) {
              const el = parent[i];
              el.classList.remove('is-active');
            }
            document.body.classList.add('is-nav-active');
            _parent.classList.add('is-active');
          }
        }
        e.preventDefault();
      });
    };
  }

  for(let i = 0; i < trigger.length; i++) {
    const el = trigger[i];
    el.addEventListener('click', function(e) {
      const ww = window.document.documentElement.clientWidth;
      if(ww <= 1023) {
        const _parent = closest(el, 'js-nav-tablet');
        if(_parent) {
          const child = _parent.querySelector('.js-nav-child-tablet');
          if(!child.classList.contains('is-animate')) {
            if(el.classList.contains('is-tablet-active')){
              el.classList.remove('is-tablet-active');
              DOMAnimations.slideUp(child);
            } else {
              el.classList.add('is-tablet-active');
              DOMAnimations.slideDown(child);
            }
          }
        }
        e.preventDefault();
      }
      if(!el.classList.contains('is-parent-link-active')) {
        e.preventDefault();
      }
    });
  };

  const spNavTrigger = document.getElementById('sp-nav-trigger');
  spNavTrigger.addEventListener('click', function(e) {
    document.body.classList.remove('is-lang-nav-active');
    document.body.classList.remove('is-nav-active');
    for(let i = 0; i < parent.length; i++) {
      const el = parent[i];
      el.classList.remove('is-active');
    }
    if(document.body.classList.contains('is-tablet-nav-active')){
      document.body.classList.remove('is-tablet-nav-active');
    } else {
      document.body.classList.add('is-tablet-nav-active');
    }
    e.preventDefault();
  });

  const overlay = document.getElementById('nav-overlay');
  overlay.addEventListener('click', function(e) {
    document.body.classList.remove('is-lang-nav-active');
    document.body.classList.remove('is-nav-active');
    document.body.classList.remove('is-tablet-nav-active');
    for(let i = 0; i < parent.length; i++) {
      const el = parent[i];
      el.classList.remove('is-active');
    }
    e.preventDefault();
  });
}